export enum ContasPagarRefinamentoEnum {
    NumeroDocumento = 2,
    Historico = 3,
}
